import { render } from "./ProduccionInforme.vue?vue&type=template&id=5aa5a385"
import script from "./ProduccionInforme.vue?vue&type=script&lang=js"
export * from "./ProduccionInforme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/informes/ProduccionInforme.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aa5a385"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aa5a385', __exports__)) {
    api.reload('5aa5a385', __exports__)
  }
  
  module.hot.accept("./ProduccionInforme.vue?vue&type=template&id=5aa5a385", () => {
    api.rerender('5aa5a385', render)
  })

}


export default __exports__